import { render } from "./Variables.vue?vue&type=template&id=45036b9c&scoped=true"
import script from "./Variables.vue?vue&type=script&lang=js"
export * from "./Variables.vue?vue&type=script&lang=js"

import "./Variables.vue?vue&type=style&index=0&id=45036b9c&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/flint.ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45036b9c"]])

export default __exports__